<template>
  <div :class="$style.container">
    <el-dialog
      v-if="visible"
      :custom-class="customCls"
      :visible="true"
      :title="title"
      :append-to-body="true"
      @close="setVisible(false)"
    >
      <div :class="$style.full_icon" @click="setFullscreen">
        <i class="el-icon-full-screen"></i>
      </div>

      <div :class="[$style.content]" v-html="content"></div>
    </el-dialog>

    <Button :class="$style.btn" type="text" @click="setVisible(true)">
      《{{ title }}》
    </Button>
  </div>
</template>

<script>
export default {
  name: "AgreementPopup",
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    content: {
      type: String,
      default: "",
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      fullscreen: false,
    };
  },
  computed: {
    customCls() {
      const cls = this.$style.dialog;
      const cls2 = this.fullscreen ? this.$style.fullscreen : "";
      return cls + " " + cls2;
    },
  },
  methods: {
    setVisible(v) {
      this.visible = v;
    },
    setFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    close() {
      this.$emit("close");
      this.fullscreen = false;
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  display: inline-block;

  .btn {
    color: $theme-blue-color;

    &:hover {
      color: rgba(2, 117, 255, 0.8);
    }
  }
}

::v-deep .dialog {
  position: relative;
  width: 800px;
  transition: all 0.3s;

  :global {
    .el-dialog__body {
      height: 75vh;
      padding-top: 20px;
      margin-right: 3px;
      @include scrollbar();
    }

    .el-icon-full-screen {
      font-size: 16px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }

  .full_icon {
    position: absolute;
    top: 14px;
    right: 50px;
  }

  .content {
    h2 {
      font-size: 18px;
      margin-bottom: 12px;
      border-bottom: 1px dashed #f1f1f1;
    }

    p {
      line-height: 28px;
    }
  }

  &.fullscreen {
    width: 100%;
    height: 100vh;

    :global {
      .el-dialog__header {
        border-radius: 0;
      }

      .el-dialog__body {
        height: calc(100vh - 44px);
        padding: 0;
        margin-right: 5px;
        border-radius: 0;
      }
    }

    .content {
      padding: 20px 50px 50px;
    }
  }
}
</style>
